import Axios, { Response } from '../utils/Axios';

const UtilController = {
  // 호텔소개 이미지 업로드
  IntroLogoUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/upload`;
      const response: any = await Axios.multipartPost(
        sUrl,
        image,
        store_id,
        'admin_recommend_logo',
      );
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로고 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 호텔소개 이미지 업로드
  IntroImageUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/upload`;
      const response: any = await Axios.multipartPost(
        sUrl,
        image,
        store_id,
        'admin_recommend_card_image',
      );
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
// store_logo: 로고 이미지
// store_image: 가게 이미지(매장 소개)
// product_image: 상품 이미지
// set_image: 세트메뉴 이미지
// business_registration: 사업자 등록증

export default UtilController;
